// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_MessagesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_MessagesResponse — GET /franchisor-channels/messages
 * (paged log read, newest first).
 */
import type { FranchisorChannels_MessageRow } from './FranchisorChannels_MessageRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FranchisorChannels_MessagesResponseDados {
rows: FranchisorChannels_MessageRow[]
}

export type FranchisorChannels_MessagesResponse = ApiResponse<FranchisorChannels_MessagesResponseDados>;

registerResponseContract('FranchisorChannels_MessagesResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                  { type: 'number',  required: true },
      trigger_key:         { type: 'string',  required: false },
      channel_id:          { type: 'number',  required: false },
      franquia_id:         { type: 'number',  required: true },
      recipient:           { type: 'string',  required: false },
      recipient_sub:       { type: 'string',  required: false },
      template_id:         { type: 'number',  required: false },
      provider_message_id: { type: 'string',  required: false },
      status:              { type: 'string',  required: false },
      detail:              { type: 'string',  required: false },
      created_at:          { type: 'string',  required: false },
    },
  },
})
